import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './BrandBand.scss';

class BrandBand extends Component {
  render() {
    return (
      <div>
        <div className="slds-brand-band-bg" />
        <div className="slds-brand-band slds-brand-band_medium slds-template_default">
          {this.props.children}
        </div>
      </div>
    );
  }
}

BrandBand.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};

export default BrandBand;
